import { TApplicationState } from '../../types/redux';

export function getIsFavorite(state: TApplicationState) {
  const {
    newbuilding: { isFavorite },
  } = state;

  return Boolean(isFavorite);
}
